import { useAssigned } from './useAssigned'
import { useGetByEngagementId } from './useGetByEngagementId'
import { useGetRandomTask } from './useGetRandomTask'
import { fetchResolvedTasks, useGetResolved, useGetResolvedWithInfiniteQuery } from './useGetResolved'
import { fetchTasksEngagement, useGetTasksEngagement } from './useGetTasksEngagement'
import { useResolution, useResolutionV1 } from './useResolution'

export const tasks = {
  getByEngagementId: useGetByEngagementId,
  getTasksEngagement: useGetTasksEngagement,
  fetchTasksEngagement,
  getRandomTask: useGetRandomTask,
  assignTask: useAssigned,
  sendResolution: useResolution,
  sendV1Resolution: useResolutionV1,
  getResolved: useGetResolved,
  getResolvedInfinite: useGetResolvedWithInfiniteQuery,
  fetchResolvedTasks,
}
